import React from 'react';

import Flex from '../Flex';

const Row = props => <Flex mx={-2} {...props} />;

export default Row;
